var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 6H3v4h1v10.5h15.5v-10h-4L14 9h5.5v1H21V6zm-9 2.25s.848.823 2.178 2.15h-.002c.7.7 2.277 2.44 2.277 4.167a2.087 2.087 0 01-2.087 2.087 2.078 2.078 0 01-1.781-1.005h-.001a.218.218 0 00-.164-.082c-.106 0-.205.076-.193.17.08.621.43 2.153 1.809 2.67H9.963c1.379-.517 1.729-2.049 1.81-2.67.01-.094-.087-.17-.194-.17a.22.22 0 00-.164.081 2.086 2.086 0 01-3.869-1.08c0-1.73 1.577-3.467 2.277-4.168 1.328-1.327 2.177-2.15 2.177-2.15zM4.5 9H10l-1.5 1.5h-4V9z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5C10 5.167 6.5 4 8.5 2s3.166 1.5 3.5 3.5zM12 5.5c2-.333 5.5-1.5 3.5-3.5S12.335 3.5 12 5.5z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 10.404l.565 1.74h1.832l-1.482 1.077.566 1.741-1.481-1.076-1.48 1.076.564-1.74-1.481-1.077h1.832l.565-1.741z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 9V7h17v2h-1v10.5h-15V9h-1zM3 10.5a1 1 0 01-1-1v-3a1 1 0 011-1h18a1 1 0 011 1v3a1 1 0 01-1 1V20a1 1 0 01-1 1H4a1 1 0 01-1-1v-9.5z",
    fill: "currentColor"
  })));
}
SvgPrFilled.displayName = 'PrFilled';
export default SvgPrFilled;